import './App.css';
import Chat from './Chat.tsx';

function App() {
  return (
      <Chat />
  );
}

export default App;
